import React, { useState } from 'react';
import './CommonStyles.css';
import './Products.css'; // Reuse Product styles for layout, tabs, and tables
import './ProductsActions.css'; // Reuse Product action styles
import './MobileResponsive.css';

import Customers from './Customers';
import Suppliers from './Suppliers';
import CustomerGroups from './CustomerGroups';
import ImportContacts from './ImportContacts';

const Contacts = () => {
  const [activeTab, setActiveTab] = useState('customers');
  const [showFilters, setShowFilters] = useState(false);
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState(''); // Lifted search state

  // Reset filters and search when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilterStatus('all');
    setSearchTerm('');
  };

  return (
    <div className="products-container">
      {/* Main Card: Tabs + Content */}
      <div className="main-card">
        {/* Tabs */}
        <div className="product-tabs">
          <div
            className={`product-tab ${activeTab === 'suppliers' ? 'active' : ''}`}
            onClick={() => handleTabChange('suppliers')}
          >
            <i className="fa fa-truck"></i> Suppliers
          </div>
          <div
            className={`product-tab ${activeTab === 'customers' ? 'active' : ''}`}
            onClick={() => handleTabChange('customers')}
          >
            <i className="fa fa-users"></i> Customers
          </div>
          <div
            className={`product-tab ${activeTab === 'customer_groups' ? 'active' : ''}`}
            onClick={() => handleTabChange('customer_groups')}
          >
            <i className="fa fa-layer-group"></i> Customer Groups
          </div>
          <div
            className={`product-tab ${activeTab === 'import_contacts' ? 'active' : ''}`}
            onClick={() => handleTabChange('import_contacts')}
          >
            <i className="fa fa-upload"></i> Import Contacts
          </div>
          <div
            className={`product-tab ${activeTab === 'map' ? 'active' : ''}`}
            onClick={() => handleTabChange('map')}
          >
            <i className="fa fa-map-marker"></i> Map
          </div>

        </div>

        {/* Content Area */}
        <div className="contacts-content">
          {activeTab === 'customers' && <Customers isActive={activeTab === 'customers'} filterStatus={filterStatus} searchTerm={searchTerm} onSearchChange={setSearchTerm} onShowFilters={() => setShowFilters(true)} />}
          {activeTab === 'suppliers' && <Suppliers isActive={activeTab === 'suppliers'} filterStatus={filterStatus} searchTerm={searchTerm} onSearchChange={setSearchTerm} onShowFilters={() => setShowFilters(true)} />}
          {activeTab === 'customer_groups' && <CustomerGroups isActive={activeTab === 'customer_groups'} searchTerm={searchTerm} onSearchChange={setSearchTerm} onShowFilters={() => setShowFilters(true)} />}
          {activeTab === 'import_contacts' && <ImportContacts isActive={activeTab === 'import_contacts'} />}
          {activeTab === 'map' && (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              <h3>🗺️ Map View</h3>
              <p>Map functionality coming soon.</p>
            </div>
          )}
        </div>
      </div>

      {/* Filter Modal Popup */}
      {showFilters && (
        <div className="modal-overlay" onClick={() => setShowFilters(false)}>
          <div className="modal-container filter-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px', width: '95%' }}>
            <div className="modal-header">
              <h2>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '0.5rem', verticalAlign: 'middle' }}>
                  <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                </svg>
                Filters
              </h2>
              <button className="modal-close-btn" onClick={() => setShowFilters(false)}>✕</button>
            </div>
            <div className="modal-content" style={{ padding: '1.5rem' }}>
              <div className="filter-row">
                {(activeTab === 'customers' || activeTab === 'suppliers') && (
                  <div className="filter-group">
                    <label>Status:</label>
                    <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                      <option value="all">All ({activeTab === 'customers' ? 'Customers' : 'Suppliers'})</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                )}
                {activeTab !== 'customers' && activeTab !== 'suppliers' && (
                  <div className="filter-group">
                    <p style={{ color: '#666', fontStyle: 'italic' }}>No filters available for this section.</p>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn close-btn" onClick={() => setShowFilters(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contacts;
